import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {

constructor() { }
public isUserLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
public userName:BehaviorSubject<string> = new BehaviorSubject<string>("");
public userType:BehaviorSubject<string> = new BehaviorSubject<string>("");
public choosenModule:BehaviorSubject<number> = new BehaviorSubject<number>(0);
public idleTimeoutValue:BehaviorSubject<number> = new BehaviorSubject<number>(0);
public tokenExpiryTimeValue:BehaviorSubject<number> = new BehaviorSubject<number>(0);
public InactivityTimeValueForAutomaticLogout:BehaviorSubject<number> = new BehaviorSubject<number>(0);

}
